import { useState } from "react";
import { Link, router } from "@inertiajs/react";
import I from "../../components/Icons";
import { common, pick } from "../../lib/i18n";

interface Props {
  errors?: string[];
  sent?: boolean;
}

const copy = {
  pl: { heading: "Zapomniałeś hasła?", sent: "Jeśli podany adres e-mail istnieje w naszej bazie, wysłaliśmy na niego instrukcje resetu hasła. Sprawdź skrzynkę odbiorczą.", submit: "Wyślij instrukcje" },
  en: { heading: "Forgot your password?", sent: "If the given e-mail address exists in our database, we've sent password reset instructions to it. Check your inbox.", submit: "Send instructions" },
};

export default function ForgotPassword({ errors = [], sent = false }: Props) {
  const t = pick(copy);
  const c = common();
  const [email, setEmail] = useState("");

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    router.post("/users/password", { user: { email } });
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: "var(--bg)", padding: 24 }}>
      <div style={{ width: "100%", maxWidth: 400 }}>
        <Link href="/" className="logo" style={{ display: "inline-flex", marginBottom: 32 }}>
          <span className="logo-mark" />
          <span>AvantoAI</span>
        </Link>

        <div className="panel">
          <div className="panel-hd"><h3>{t.heading}</h3></div>
          <div className="panel-body">
            {errors.length > 0 && (
              <div style={{ marginBottom: 14, padding: "8px 12px", background: "oklch(0.62 0.20 25 / 0.08)", border: "1px solid oklch(0.62 0.20 25 / 0.3)", borderRadius: "var(--radius)", fontSize: 12, color: "var(--danger)" }}>
                {errors.map((e, i) => <div key={i}>{e}</div>)}
              </div>
            )}

            {sent ? (
              <div style={{ fontSize: 13, color: "var(--muted)" }}>
                {t.sent}
              </div>
            ) : (
              <form onSubmit={submit}>
                <div className="field" style={{ marginBottom: 18 }}>
                  <label>{c.auth.email}</label>
                  <input className="input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
                </div>
                <button type="submit" className="btn btn-accent" style={{ width: "100%", justifyContent: "center", height: 36 }}>
                  {I.spark} {t.submit}
                </button>
              </form>
            )}
          </div>
        </div>

        <div style={{ textAlign: "center", marginTop: 16, fontSize: 12.5, color: "var(--muted)" }}>
          <Link href="/users/sign_in" style={{ color: "var(--ink)", fontWeight: 500 }}>{c.auth.backToLogin}</Link>
        </div>
      </div>
    </div>
  );
}
